import { EnvironmentSwitcher } from "./EnvironmentSwitcher";

interface HeaderProps {
  userEmail: string | null;
  onSignOut: () => void;
  /**
   * Opens the off-canvas nav drawer (V2M-DEV-610 mobile pass — `NavSidebar`
   * is `md:hidden`-collapsed by default below the `md` breakpoint, this is
   * its only trigger). Always required: the button below is only ever
   * hidden via CSS (`md:hidden`), not omitted, so it must always have a
   * handler wired up by the caller.
   */
  onMenuClick: () => void;
}

export function Header({ userEmail, onSignOut, onMenuClick }: HeaderProps) {
  return (
    <header className="bg-white border-b border-slate-200 px-3 sm:px-6 py-3 flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
      <div className="flex items-center gap-2 sm:gap-3 min-w-0">
        <button
          onClick={onMenuClick}
          type="button"
          aria-label="Toggle navigation menu"
          data-testid="nav-menu-toggle"
          className="md:hidden -ml-1 p-2 rounded-md text-slate-600 hover:bg-slate-100 hover:text-slate-900 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
        <h1 className="text-lg font-semibold text-slate-900 truncate">
          <span className="hidden sm:inline">VoiceToMail Admin</span>
          <span className="sm:hidden">V2M Admin</span>
        </h1>
      </div>
      <div className="flex items-center gap-3 sm:gap-6">
        <EnvironmentSwitcher />
        {userEmail && (
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center shrink-0">
              <span className="text-white text-sm font-medium">
                {userEmail.charAt(0).toUpperCase()}
              </span>
            </div>
            {/* Full email hides below `sm` — the avatar's initial plus the
                header's own width budget isn't enough to keep it legible
                next to the nav toggle, env switcher and sign-out control on
                a 390px phone; nothing here is lost data (see UsersPage for
                the actual per-user email, this is just the signed-in
                operator's own address). */}
            <span className="hidden sm:inline text-sm text-slate-600">{userEmail}</span>
          </div>
        )}
        <button
          onClick={onSignOut}
          type="button"
          className="text-sm text-slate-600 hover:text-slate-900 px-3 py-1.5 rounded-md hover:bg-slate-100 transition-colors whitespace-nowrap"
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}
